import ReopeningSearch from "../../../../src/components/marketing/reopeningSearch";
import * as React from 'react';
export default {
  ReopeningSearch,
  React
};